const i18n = {
  'inventoryChange': {
    'tab': {
      'pending': '等候中',
      'done': '已完成',
      'void': '已作廢',
    },
    'name': '庫存異動單',
    'table': {
      'pending': {
        'title': '庫存異動單列表 - 待簽核',
      },
      'title': '庫存異動單列表',
      'selected': '已選擇 {count} 筆庫存異動單',
      'header': {
        'sn': '庫存異動單號',
        'source': '庫存異動單位',
        'sourceName': '庫存異動單位',
        'createdBy': '填表人',
        'createdAt': '建立日期',
        'date': '庫存異動日期',
      },
      'detail': {
        'sn': '庫存異動單號',
        'source': '庫存異動單位',
        'sourceName': '庫存異動單位',
        'createdBy': '填表人',
        'createdAt': '建立日期',
        'date': '庫存異動日期',
        'note': '備註',
        'merchandise': '商品',
        'merchandiseName': '商品名稱',
        'merchandiseCode': '商品品號',
      },
    },
    'dialog': {
      'title': {
        'add': '新增庫存異動單',
        'edit': '編輯庫存異動單',
      }
    },
    'merchandise': {
      'code': '品號',
      'name': '品名',
      'unitPrice': '單價',
      'stock': '庫存數量',
      'changeType': '異動類型',
      'amount': '異動數量',
      'sku': '單位',
      'price': '金額',
      'note': '備註',
      'statusText': '狀態',
      'unit': '單位',
    }
  },
  'editInventoryChange': {
    'table': {
      'title': '異動商品清單',
      'selected': '已選擇 {count} 個項目',
    },
    'selectMerchandise': '選擇商品',
    'addLotNumber': '新增批號',
    'removeMerchandise': '移除商品',
  }
}
export default i18n
